var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopilotsBoxIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_303_163",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_303_163",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACV0lEQVR4nO2azU4UQRhFz0p3GlaCEIxbfBDDwjdRdjD4JEZ4H4wLxQfQjfEFhIUDm890rBgy6fnvrrpdfU/yJSSTGarO3LozTQPGGGOMMcYYY4wxZh5PgVPgK3ADxMDmBviS9vBE9W1+BfwQkBUdzXfgCMEk/xSQEx3PL2AHIT4ISImeptmbBIfAnYCQ6GnugZcIcCEgI3qej8ppbt6AoXGpmuoL1YVtyIsFwSmW6trSLJvq2tIsmepa0yyX6lrTLJXq2tMsk+ra0yyT6vsRpHmVVPdO6au0EBmLxqIpnUInmvLiXB2Ul+qOxqKLJy6caIpLcnVQXuDoO3oKnAHP00wK36us9oLlrGUtjWyL7ljCXovoXYvOd1TD1WHRW6GWoBBbT2eobSzE1mPRWDRO9ACOaoitx9WBReNED+Cohth6XB1YNE70AI5qiK3H1YFF40RnOqp36Y/4u2km6Y7KutUxbXmdvu7CDLI6Ji2/53hG9rL1TNNzZjm3aP5LatLXxmvgzwqim9S+mfP4M4tmqeiHsuexSDLpRq6rg38SmuO9iOMNH2t4b9Es7ddtme350X8YxgoVsC4P+92i6Ud235IH+/UuOpSdQ3IVomML2bkkVyM6NpCdU3JVomMN2bklVyc6VpBdQnKVomOB7FKSqxUd6cLjPP1X6V76ua+LkVGLDrGxaCya0ikcVKJvBTYZhed3DtGfBTYahedTDtEnAhuNwvM2h+jHwDeBzUahuQYekYmDkcq+BvbJTJPsd6mvav6AvAWuUl1kS7IxxhhjjDHGGGMMwvwFICSFigvEZXUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotsBoxIcon1);
export default __webpack_public_path__ + "static/media/CopilotsBoxIcon1.aac4b3919efd330c21647ad4683998c7.svg";
export { ForwardRef as ReactComponent };